<!-- <app-announcement-bar [announcements]="announcements"></app-announcement-bar> -->
<app-header></app-header>
<router-outlet />
<button tabindex="-1" aria-hidden="true" class="d-none btn-sm btn btn-outline-primary"
    (click)="fetchProductsFromStoreFrontAPIForCache()">refresh product
    cache</button>
<app-footer></app-footer>